<template>
    <div class="card card-tasks">
        <Overlay v-if="this.loading"></Overlay>
        <Loading v-if="this.loading"></Loading>
        <div class="card-header">
            <div class="dropdown">
                <button type="button" class="btn btn-link dropdown-toggle btn-icon" data-toggle="dropdown">
                    <i class="tim-icons icon-settings-gear-63"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                    <a v-if="hasPermForBoard('add')" class="dropdown-item" v-on:click="showCreateTask">Create task</a>
                    <a class="dropdown-item" v-on:click="retrieveTasks">Reload tasks</a>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 text-left mb-3">
                    <h2 class="card-title">{{ boardTitle }}</h2>
                </div>
            </div>
            <div class="categories" id="categories-list">
                    <div class="card-category"
                         v-for="category in getCategoriesByTasks()" :key="category.id"
                       v-on:click="toggleCategory(category.title)"
                       v-bind:class="{ active: categoriesShowing.includes(category.title) }"
                       v-tooltip="getTooltipCategory(category)"
                    >
                        <div class="category-bg" :style="{ width: getPercentageCategory(category.count, category.total)+'%' }"></div>
                        <div class="category-title">{{ category.title }} <span class="badge-dark badge">{{ category.count }}</span></div>
                    </div>
                  </div>
        </div>
        <div class="card-body mt-3" id="tasks">

            <TaskCreate v-if="hasPermForBoard('add')" v-show="isCreating" parent_id="0" @on-create="createTask" v-bind:categories="getCategoriesByTasks()"></TaskCreate>

            <task v-for="task in getParents()"
                  v-if="hasPermForBoard('get')"
                  :key="task.id"
                  v-bind:taskindex="getTaskIndex(task.id)"
                  v-bind:task="task"
                  v-bind:boardid="getBoardId()"
                  child="0"
                  @on-edit="editTaskRepository"
                  @on-delete="deleteTaskRepository"
                  v-bind:categories="getCategoriesByTasks()"
            ></task>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Task from '../components/Task.vue'
import TaskCreate from '../components/TaskCreate.vue'
import ApiService from "../common/api.service";
import Overlay from "./Overlay";
import Loading from "./Loading";

export default {
    name: 'board',
    props: ['boardId', 'boardTitle'],
    components: {
        Overlay,
        Task,
        TaskCreate,
        Loading
    },
    watch: {
        boardId: function(newVal, oldVal){
            if(newVal != 0)
                this.retrieveTasks();
        }
    },
    data() {
        return {
            tasks: [],
            categories: [],
            categoriesShowing: [],
            loading: false,
            errored: false,
            isCreating: false,
            animated: false
        }
    },
    methods: {
        getPercentageCategory(finished, total){
            return 100 - (finished / total) * 100;
        },
        hasPermForBoard(perm){
            return this.$root.hasPermForBoard(perm, this.boardId);
        },
        getBoardId(){
            return this.boardId;
        },
        showCreateTask: function(){
            this.isCreating = !this.isCreating;
        },
        orderDescendantByProgress: function(a,b){
            return a.progress - b.progress;
        },
        orderDescendantByTime: function(a,b){
            return b.startedTime - a.startedTime;
        },
        orderAscendant: function(a,b){
            return a.startedTime - b.startedTime;
        },
        orderDescendantCategories: function(a,b){
            return b.count - a.count;
        },
        getCategoriesByTasks: function(){
            let categories = [...new Set(this.tasks.map(x => x.category))];
            let categoriesData = [];
            for(let category in categories){
                let nameCategory = categories[category];
                categoriesData.push({
                    id: category,
                    title: nameCategory,
                    count: this.getTasksFromCategory([nameCategory], true, true).length,
                    total: this.getTasksFromCategory([nameCategory], false, true).length
                });
            }
            return categoriesData.slice().sort(this.orderDescendantCategories);
        },
        getTooltipCategory(category){
            return (category.count == 0 ? 'All finished ('+category.total+')' : category.count+'/'+category.total+' finished');
        },
        getTaskOrderByProgressAndTime: function(tasks){
            return tasks.slice().sort(this.orderDescendantByTime).slice().sort(this.orderDescendantByProgress);
        },
        getTasksFromCategory: function(categories, onlyTodo, childrenSeparated){
            let catAmount = categories.length;
            let allParentOrChildren = this.tasks.filter(el => el.parent_id == 0 && categories.includes(el.category)).slice();
            return this.getTaskOrderByProgressAndTime(this.tasks.filter(el =>
                (childrenSeparated ? true : (catAmount == 1 ? allParentOrChildren.filter(p=>p.id==el.parent_id).length==0 : el.parent_id == 0))
                && categories.includes(el.category)
                && (onlyTodo && el.progress==0 || !onlyTodo)));
        },
        getParents: function(){
            return this.getTasksFromCategory(this.categoriesShowing);
        },
        getChildren: function(taskId){
            return this.getTaskOrderByProgressAndTime(this.tasks.filter(el => el.parent_id == taskId));
        },
        hasChildren: function(taskId){
            return this.tasks.find(x => x.parent_id == taskId) != null;
        },
        toggleCategory: function(category){
            if(this.categoriesShowing.includes(category)){
                this.categoriesShowing.splice(this.categoriesShowing.indexOf(category), 1);
            } else {
                this.categoriesShowing.push(category);
                this.animated = true;
            }
        },
        editTaskRepository(taskIndex, task, oldCategory, newCategory) {
            let oldCategoryIndex = this.categoriesShowing.findIndex(x => x == oldCategory);

            if (oldCategory != newCategory)
                this.$root.$set(this.categoriesShowing, oldCategoryIndex, newCategory);

            this.$root.$set(this.tasks, taskIndex, task);
        },
        deleteTaskRepository(taskIndex){
            this.tasks.splice(taskIndex, 1);
        },
        getTaskIndex: function(taskId){
            return this.tasks.findIndex(x => x.id == taskId);
        },
        getTask: function(taskId){
            return this.tasks[this.getTaskIndex(taskId)];
        },
        getCurrentCategory: function(){
            return this.categoriesShowing.length === 1 ? this.categoriesShowing[0] : '';
        },
        createTask: function(text, category, desc, parent_id){
            this.loading = true;
            let data = {
                text: text,
                category: category,
                desc: desc,
                parent_id: parent_id,
                startedTime: +new Date()
            };
            axios.post(ApiService.getAction('tasks', 'add', this.boardId), data).then( (response) => {
                this.tasks.push(response.data.task);
                this.animated = true;
            }).finally(() => this.loading = false);
        },
        retrieveTasks(){
            if(this.boardId == 0) return;
            this.loading = true;
            axios
                .get(ApiService.getAction('tasks', 'get', this.boardId))
                .then(response => {
                    console.log(response);
                    this.tasks = response.data.tasks;
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)
        }
    },
    mounted(){
        this.retrieveTasks();
    }
}
</script>
